import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shopping-bag-1"><path d="M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8M4.75 3.75L3.75 20.25H20.25L19.25 3.75H4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShoppingBag1;
